module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_CS-10ff5047fa746f93024f287cf89cb44c.svg";